import { render, staticRenderFns } from "./LogoLargeMonoWhiteCpt.vue?vue&type=template&id=4f08c5e4&"
import script from "./LogoLargeMonoWhiteCpt.vue?vue&type=script&lang=ts&"
export * from "./LogoLargeMonoWhiteCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
